module.exports = __webpack_public_path__ + "img/belgium-colorectal-cancer-female.b0176caf.png";